export * from './menu.component';
export * from './menu.icon.component'
export * from './menu.item.metadata';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/menu/index.ts